module.exports = __webpack_public_path__ + "img/ZA.8b18b8df.svg";